export const createProviderMapping = `
    mutation createProviderMapping($input: CreateProviderMappingInput!) {
        createProviderMapping(input: $input) {
            id
            entityType
            localEntityId
            billingProviderId
            providerEntityId
            syncStatus
            providerSpecificData
            lastSyncAt
            syncError
            created
            updated
            createdByUsername
        }
    }
`;

export const updateProviderMapping = `
    mutation updateProviderMapping($input: UpdateProviderMappingInput!) {
        updateProviderMapping(input: $input) {
            id
            entityType
            localEntityId
            billingProviderId
            providerEntityId
            syncStatus
            providerSpecificData
            lastSyncAt
            syncError
            created
            updated
            createdByUsername
        }
    }
`;

export const deleteProviderMapping = `
    mutation deleteProviderMapping($input: DeleteProviderMappingInput!) {
        deleteProviderMapping(input: $input)
    }
`;